export const neasc = {
  title: "Accréditation Internationale NEASC",
  subtitle: "Gándara International School est accrédité par la New England Association of Schools and Colleges (NEASC), l'une des organisations d'accréditation éducative les plus prestigieuses au monde.",
  badge: "École Accréditée NEASC",
  learnMore: "En savoir plus sur NEASC",
  learnMoreUrl: "https://www.neasc.org",
  benefits: {
    quality: {
      title: "Garantie de Qualité",
      description: "Vérification externe et indépendante que nous respectons les normes éducatives internationales les plus élevées."
    },
    recognition: {
      title: "Reconnaissance Mondiale",
      description: "Nos diplômes et certificats sont reconnus par les institutions éducatives du monde entier."
    },
    improvement: {
      title: "Amélioration Continue",
      description: "Engagement permanent envers l'évaluation et l'amélioration de nos programmes, installations et méthodologies."
    },
    transferability: {
      title: "Transférabilité",
      description: "Facilite la transition des étudiants vers d'autres écoles accréditées en Espagne et à l'étranger."
    }
  }
};
